$(document).ready(function () {
  $("body").on("click", ".accordion-content summary", function (e) {
    e.preventDefault();
    $(this)
      .closest(".accordion-content")
      .find(".accordion_answer")
      .slideToggle();
    $(this).closest(".accordion-content").toggleClass("active");
  });
  var padding_d = $("header").innerHeight();
  if ($(window).width() <= 767) {
    padding_d = $("#shopify-section-header nav").innerHeight();
  }
  $(".need_top_padding").css("padding-top", padding_d + "px");

  $(window).on("load resize", function () {
    var padding = $("header").innerHeight();
    if ($(window).width() <= 767) {
      padding = $("#shopify-section-header nav").innerHeight();
    }
    $(".need_top_padding").css("padding-top", padding + "px");
  });
  $("body").on("click", ".homepage-featured-box-btn.openpopup", function (e) {
    e.preventDefault();
    $(".popup_contact").addClass("active");
  });
  $("body").on("click", ".popup_contact .close_popup", function (e) {
    e.preventDefault();
    $(".popup_contact").removeClass("active");
  });
  if (
    window.location.href.indexOf("contact_posted=true#contact_form") > -1 &&
    $(".popup_contact").length > 0
  ) {
    $(".popup_contact").addClass("active");
    window.history.pushState(
      { html: "", pageTitle: "" },
      "",
      "book-a-consultation"
    );
  }
  // $('body').on('submit','.popup_contact form',function(e){
  //   var form = $(this);
  //   var x = true;
  //   if($(form).find('#ContactFormNAME').val().trim() == ''){
  //     x = false;
  //   }
  //   if($(form).find('#ContactFormNAME').val().trim() == ''){
  //     x = false;
  //   }
  // });
  $(".bxslider").bxSlider({
    autoHover: true,
    auto: true,
    slideWidth: 350,
    minSlides: 1,
    maxSlides: 6,
    controls: true,
    pager: false,
    speed: 500,
    captions: true,
    slideMargin: 4,
  });
  $('body').on('click', '.tea', function(e){
    // e.preventDefault();
      // window.location.href = '/cart';
    console.log('Clicked...');
  });
});
